import { Component, Input } from '@angular/core';

/**
 * The standard page header panel: hero icon (the page's menu icon), title,
 * one-line description, and an optional right-hand slot for actions. One
 * component so every page shares the same card, spacing and tokens - the
 * Use it as `<app-page-header class="col-12" ...>` inside the page's `.grid`.
 * Project a search/filter row into the card with an element marked `headerFooter`.
 */
@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  // A plain block with NO margins of its own: pages place it as a `col-12`
  // inside their PrimeFlex `.grid`, so flush edges and the 1rem gap to the
  // content come from the grid contract (-0.5rem grid margin + 0.5rem column
  // padding) - the idiomatic layout, no pt-0 / margin-top:0 overrides anywhere.
  styles: [':host { display: block; }'],
})
export class PageHeaderComponent {
  /** PrimeIcons class, e.g. 'pi pi-book' - use the page's main-menu icon. */
  @Input() icon = 'pi pi-file';
  @Input() title = '';
  @Input() description = '';
}
